/**
 * Which of the two replies a compared turn is showing, per run. Lifted out of the bubble
 * because the turn's author label has to follow the switch.
 */

import { atom, useAtomValue } from 'jotai';
import { Bot, UserRound } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type ReplySide = 'ai' | 'agent';

export const replySideAtom = atom<Record<string, ReplySide>>({});

export const setReplySideAtom = atom(null, (get, set, requestId: string, side: ReplySide) => {
  set(replySideAtom, { ...get(replySideAtom), [requestId]: side });
});

/** Defaults to the AI's own reply: it is that turn's text until someone asks otherwise. */
export const useReplySide = (requestId: string): ReplySide => useAtomValue(replySideAtom)[requestId] ?? 'ai';

export const replySideIcon = (side: ReplySide): LucideIcon => (side === 'ai' ? Bot : UserRound);
